/*
  attrac-jquery-fix.js
  El jquery.js de este tema esta compilado SIN el modulo ajax
  ("3.6.4 -ajax,-ajax/jsonp,-ajax/load,..."), y la app Attrac usa
  $.get / $.getJSON / $.ajax. Al faltar, su script lanza TypeError y su
  catch vacio lo silencia: la campana no se descarga y el popup no sale.

  Este fichero SOLO define lo que no existe. Si el metodo ya esta, no lo toca.
  Devuelve un objeto tipo jqXHR con .done() / .fail() / .always() porque
  Attrac los encadena. Nunca rechaza: no genera errores no capturados.
*/
(function () {
  var q = window.jQuery;
  if (!q) return;

  function cuerpo(d) { return d == null ? undefined : (typeof d === 'string' ? d : new URLSearchParams(d).toString()); }
  function conQuery(u, d) { var s = cuerpo(d); return s ? u + (u.indexOf('?') > -1 ? '&' : '?') + s : u; }

  function peticion(url, opciones, comoJson, cbExito, etiqueta) {
    var exitos = [], fallos = [], siempre = [];
    var terminado = false, error = null, datos;
    function disparar(lista, arg) {
      for (var i = 0; i < lista.length; i++) { try { if (typeof lista[i] === 'function') lista[i](arg); } catch (e) {} }
    }
    var p = fetch(url, opciones)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return comoJson ? r.json() : r.text(); })
      .then(function (d) { datos = d; if (typeof cbExito === 'function') cbExito(d); })
      .catch(function (e) { error = e; console.warn('[attrac-fix] ' + etiqueta, url, e); })
      .then(function () {
        terminado = true;
        disparar(error ? fallos : exitos, error || datos);
        disparar(siempre, datos);
        return datos;
      });
    var api = {
      done: function (cb) { if (terminado) { if (!error) disparar([cb], datos); } else exitos.push(cb); return api; },
      fail: function (cb) { if (terminado) { if (error) disparar([cb], error); } else fallos.push(cb); return api; },
      always: function (cb) { if (terminado) disparar([cb], datos); else siempre.push(cb); return api; },
      then: function (a, b) { return p.then(a, b); },
      catch: function (a) { return p.catch(a); }
    };
    return api;
  }

  if (typeof q.get !== 'function') {
    q.get = function (url, data, cb, tipo) {
      if (typeof data === 'function') { tipo = cb; cb = data; data = null; }
      return peticion(conQuery(url, data), undefined, tipo === 'json', cb, '$.get');
    };
  }

  if (typeof q.getJSON !== 'function') {
    q.getJSON = function (url, data, cb) {
      if (typeof data === 'function') { cb = data; data = null; }
      return peticion(conQuery(url, data), undefined, true, cb, '$.getJSON');
    };
  }

  if (typeof q.post !== 'function') {
    q.post = function (url, data, cb, tipo) {
      if (typeof data === 'function') { tipo = cb; cb = data; data = null; }
      return peticion(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: cuerpo(data)
      }, tipo === 'json', cb, '$.post');
    };
  }

  if (typeof q.ajax !== 'function') {
    q.ajax = function (o) {
      o = o || {};
      var metodo = (o.type || o.method || 'GET').toUpperCase();
      var url = o.url, op = { method: metodo };
      if (metodo === 'GET') {
        url = conQuery(url, o.data);
      } else {
        op.headers = { 'Content-Type': o.contentType || 'application/x-www-form-urlencoded; charset=UTF-8' };
        op.body = cuerpo(o.data);
      }
      var api = peticion(url, op, o.dataType === 'json', o.success, '$.ajax');
      if (typeof o.error === 'function') api.fail(o.error);
      if (typeof o.complete === 'function') api.always(o.complete);
      return api;
    };
  }
})();
